module.exports = __webpack_public_path__ + "img/mars-logo.bd83f44b.svg";